<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Aseguradora</label>
                    <select class="form-control" required="required" :disabled="store.disabledAseguradora" v-model="store.aseguradoraId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="aseguradora in store.aseguradoras" :key="aseguradora.id" :value="aseguradora.id">{{ aseguradora.nombre }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">Ramo</label>
                    <select class="form-control" required="required" :disabled="store.disabledRamo" v-model="store.ramoId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="ramo in store.ramos" :key="ramo.id" :value="ramo.id">{{ ramo.nombre }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">Plazo</label>
                    <select class="form-control" required="required" :disabled="store.disabledPlazo" v-model="store.plazoId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="plazo in store.plazos" :key="plazo.id" :value="plazo.id">{{ plazo.plazo }}</option>
                    </select>
                </div>
                <div>
                    <label class="control-label">Tipo</label>
                    <select class="form-control" required="required" :disabled="store.disabledTipo" v-model="store.tipoId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="tipo in store.tipos" :key="tipo.id" :value="tipo.id">{{ tipo.nombre }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">Divisa</label>
                    <select class="form-control" required="required" :disabled="store.disabledDivisa" v-model="store.divisaId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="divisa in store.divisas" :key="divisa.id" :value="divisa.id">{{ divisa.nombre }} - {{ divisa.simbolo }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">Producto</label>
                    <select class="form-control" required="required" :disabled="store.disabledProducto" v-model="store.productoId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="producto in store.productos" :key="producto.id" :value="producto.id">{{ producto.name }}</option>
                    </select>
                    <small v-if="sinProductos" class="text-muted">No hay productos disponibles para esta combinación.</small>
                </div>
            </div>
            <!-- -->
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Enroller</label>
                    <select class="form-control" required="required" :disabled="!store.productoId" v-model="store.enrolerId">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="enroller in store.enrollers" :key="enroller.id" :value="enroller.id">{{ enroller.nombre }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="control-label">Fecha de solicitud</label>
                    <input class="form-control" type="date" required="required" v-model="store.fechaSolicitud" :disabled="!store.enrolerId">
                </div>
            </div>
        </div>

        <hr class="mt-3" />
        <div class="mt-3 col-md-12">
            <p><b>* Campos obligatorios</b></p>
        </div>

        <div class="mt-3 col-md-12">
            <button type="button" class="btn btn-primary float-end" :disabled="loading" @click.prevent="onUpdateProductoYAvanza">
                {{ accionProductoLabel }}
            </button>
        </div>
    </div>
</template>

<script>
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import { useSeguroStore } from '@/stores/seguroStore';
import getField from '@/utils/getField';
import { esFamiliaSoportada } from '@/utils/familiaSeguro';

export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],
            sinProductos: false,
            loading: false,
            error: null,
        }
    },
    computed: {
        accionProductoLabel() {
            return this.store.polizaId ? 'Actualizar y avanzar' : 'Guardar y avanzar';
        },
    },
    watch: {
        'store.aseguradoraId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.updateAseguradoraNombre();
                this.store.ramoId = '';
                this.store.disabledRamo = 1;
                this.store.plazoId = '';
                this.store.disabledPlazo = 1;
                this.store.tipoId = '';
                this.store.disabledTipo = 1;
                this.store.divisaId = '';
                this.store.disabledDivisa = 1;
                this.store.productoId = '';
                this.store.disabledProducto = 1;
                this.fetchRamos();
            }
        },
        'store.ramoId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.plazoId = '';
                this.store.disabledPlazo = 1;
                this.store.tipoId = '';
                this.store.disabledTipo = 1;
                this.store.divisaId = '';
                this.store.disabledDivisa = 1;
                this.store.productoId = '';
                this.store.disabledProducto = 1;
                this.fetchPlazos();
            }
        },
        'store.plazoId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.tipoId = '';
                this.store.disabledTipo = 1;
                this.store.divisaId = '';
                this.store.disabledDivisa = 1;
                this.store.productoId = '';
                this.store.disabledProducto = 1;
                this.fetchTipos();
            }
        },
        'store.tipoId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.divisaId = '';
                this.store.disabledDivisa = 1;
                this.store.productoId = '';
                this.store.disabledProducto = 1;
                this.fecthDivisas();
            }
        },
        'store.divisaId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.productoId = '';
                this.store.disabledProducto = 1;
                this.store.enrolerId = '';
                this.store.fechaSolicitud = '';
                this.store.resetDerechoPoliza();
                this.fecthProductos();
            }
        },
        'store.productoId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.store.enrolerId = '';
                this.store.fechaSolicitud = '';
                this.store.resetDerechoPoliza();
            }
            if (newVal) {
                this.store.updateProductoNombre();
            }
        }
    },
    mounted() {
        this.fetchAseguradoras();
        this.store.fetchEnrollers();
    },
    methods: {
        async updateProducto() {
            if (!this.store.polizaId) {
                this.error = 'No se encontró polizaId para actualizar producto.';
                return false;
            }
            try {
                this.loading = true;
                this.error = null;
                const payload = this.store.buildWizardDto(3);
                const response = await api.put(`wizard/poliza/${this.store.polizaId}`, payload);
                if (response.status >= 200 && response.status < 300) {
                    const data = response.data || {};
                    this.store.polizaVersionId = getField(data, 'polizaVersionId') ?? this.store.polizaVersionId;
                    this.store.etapaWizard = 3;
                    return true;
                }
                return false;
            } catch (err) {
                this.error = 'No se pudo actualizar el producto de la póliza.';
                return false;
            } finally {
                this.loading = false;
            }
        },
        async onUpdateProductoYAvanza() {
            const ok = await this.updateProducto();
            if (ok) {
                this.$emit('nextTab');
            } else if (this.error) {
                alert(this.error);
            }
        },
        async fetchAseguradoras() {
            try {
                this.loading = true;
                this.error = null;
                this.store.aseguradoras = (await fetchAllItems("aseguradoras")).items;
                this.store.disabledAseguradora = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar las Aseguradoras.';
            } finally {
                this.loading = false;
            }
        },
        async fetchRamos() {
            try {
                this.loading = true;
                this.error = null;
                this.store.ramos = (await fetchAllItems(`ramos/aseguradora/${this.store.aseguradoraId}`)).items;
                this.store.disabledRamo = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar los Ramos.';
            } finally {
                this.loading = false;
            }
        },
        async fetchPlazos() {
            try {
                this.loading = true;
                this.error = null;
                this.store.plazos = (await fetchAllItems(`plazos/aseguradora/ramo/${this.store.aseguradoraId}/${this.store.ramoId}`)).items;
                this.store.disabledPlazo = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar los Plazos.';
            } finally {
                this.loading = false;
            }
        },
        async fetchTipos() {
            try {
                this.loading = true;
                this.error = null;
                this.store.tipos = (await fetchAllItems(`tipos/aseguradora/ramo/plazo/${this.store.aseguradoraId}/${this.store.ramoId}/${this.store.plazoId}`)).items;
                this.store.disabledTipo = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar los Tipos de Póliza.';
            } finally {
                this.loading = false;
            }
        },
        async fecthDivisas() {
            try {
                this.loading = true;
                this.error = null;
                this.store.divisas = (await fetchAllItems(`divisas/aseguradora/ramo/plazo/${this.store.aseguradoraId}/${this.store.ramoId}/${this.store.plazoId}`)).items;
                this.store.disabledDivisa = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar las Divisas.';
            } finally {
                this.loading = false;
            }
        },
        async fecthProductos() {
            try {
                this.loading = true;
                this.error = null;
                const items = (await fetchAllItems(`productos/aseguradora/ramo/plazo/divisa/${this.store.aseguradoraId}/${this.store.ramoId}/${this.store.plazoId}/${this.store.divisaId}`)).items;
                // Solo productos activos de una familia soportada (GMM o Vida): este endpoint no filtra por IsActive.
                this.store.productos = items.filter(p => p.isActive !== false && esFamiliaSoportada(p.ramoId ?? this.store.ramoId));
                this.sinProductos = this.store.productos.length === 0;
                this.store.disabledProducto = 0;
            } catch (err) {
                this.error = 'No se pudieron cargar los Productos.';
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
